<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div>
          <h5 class="d-inline-block mr-4">Poslano:</h5> {{communication.requestDate | sloDateTime}}
          <span class="float-right">
            <ButtonActionToggleVisible :active="showRequestBody" @click="showRequestBody = !showRequestBody" />
          </span>
        </div>
        <pre style="font-size: 12px;" v-if="showRequestBody">
          <div :inner-html.prop="JSON.stringify(communication.requestBody, null, 4)"></div>
        </pre>
      </v-col>
      <v-col cols="12">
        <div>
          <h5 class="d-inline-block mr-4">Prejeto:</h5> {{communication.responseDate | sloDateTime}}
          <span class="float-right">
            <ButtonActionToggleVisible :active="showResponseBody" @click="showResponseBody = !showResponseBody" />
          </span>
        </div>
        <pre style="font-size: 12px;" v-if="showResponseBody">
          <div>{{JSON.stringify(communication.responseBody, null, 4)}}</div>
        </pre>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ButtonActionToggleVisible from './ButtonActionToggleVisible'

export default {
  components: {
    ButtonActionToggleVisible
  },
  props: {
    communication: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      showRequestBody: true,
      showResponseBody: true
    }
  }
}
</script>
